import styled from 'styled-components'

import { FollowingSearchModeDropdown } from '@root/features/user/users-search/following-search-mode-dropdown'
import { useTranslation } from '@root/shared/localization'
import { Input, SearchIcon } from '@root/shared/ui-kit'

import type { FollowingsSearchMode } from '../model/followings-search-mode'

type UsersSearchProps = {
  ref?: React.RefObject<HTMLDivElement | null>
  searchQuery: string
  setSearchQuery: (searchQuery: string) => void
  searchMode?: FollowingsSearchMode
  setSearchMode?: (searchMode: FollowingsSearchMode) => void
}

export const UsersSearch = ({
  searchQuery,
  setSearchQuery,
  searchMode = 'local',
  setSearchMode = () => {},
  ref,
}: UsersSearchProps) => {
  const { t } = useTranslation()

  return (
    <Root
      size="m"
      startContent={<Icon size={16} />}
      value={searchQuery}
      onChange={(s) => setSearchQuery(s.target.value)}
      placeholder={t('search.search-by-firstname-lastname-username')}
      endContent={
        ref ? (
          <div
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{
              marginRight: '-6px',
            }}
          >
            <FollowingSearchModeDropdown
              value={searchMode}
              container={ref}
              onChange={setSearchMode}
            />
          </div>
        ) : undefined
      }
    />
  )
}

const Root = styled(Input)`
  min-width: 500px;
`

const Icon = styled(SearchIcon)`
  color: var(--text-9);
`
